import { render, staticRenderFns } from "./PurchaseComplete.vue?vue&type=template&id=cc54f166&scoped=true&"
import script from "./PurchaseComplete.vue?vue&type=script&lang=js&"
export * from "./PurchaseComplete.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseComplete.vue?vue&type=style&index=0&id=cc54f166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc54f166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc54f166')) {
      api.createRecord('cc54f166', component.options)
    } else {
      api.reload('cc54f166', component.options)
    }
    module.hot.accept("./PurchaseComplete.vue?vue&type=template&id=cc54f166&scoped=true&", function () {
      api.rerender('cc54f166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/popup/PurchaseComplete.vue"
export default component.exports